export default __webpack_public_path__ + "static/media/Info_MainNav.e7f36867.svg";